export interface GetDefaultParameterOrderRequest {
  configBranchCode: string
  searchType: string
}

export function GetDefaultParameterOrderRequestToJSON(
  value: GetDefaultParameterOrderRequest
): any {
  return {
    config_branch_code:
      value.configBranchCode !== '' ? value.configBranchCode : undefined,
    search_type: value.searchType !== '' ? value.searchType : undefined
  }
}
